import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { useProducts } from '../contexts/ProductContext';
import { useAuth } from '../contexts/AuthContext';
import { FaBox, FaClipboardList, FaDollarSign, FaUsers, FaClock, FaCheckCircle } from 'react-icons/fa';

const AdminDashboard = () => {
  const { getOrderStats } = useOrders();
  const { products } = useProducts();
  const { isAdmin } = useAuth();
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
    completedOrders: 0,
    totalRevenue: 0
  });
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const orderStats = await getOrderStats();
        setStats(orderStats);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchStats();
  }, [getOrderStats]);
  
  const availableProducts = products.filter(p => p.available);

  if (!isAdmin) {
    return (
      <div className="container text-center mt-5">
        <h2>Access Denied</h2>
        <p>You need admin privileges to access this page.</p>
        <Link to="/admin/login" className="btn btn-primary">
          Admin Login
        </Link>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container text-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h2 className="text-center mb-4">Admin Dashboard</h2>
      
      <div className="admin-dashboard">
        <div className="dashboard-card">
          <FaClipboardList size={48} className="text-primary mb-3" />
          <h3>Total Orders</h3>
          <div className="number">{stats.totalOrders}</div>
        </div>
        
        <div className="dashboard-card">
          <FaClock size={48} className="text-warning mb-3" />
          <h3>Pending Orders</h3>
          <div className="number">{stats.pendingOrders}</div>
        </div>
        
        <div className="dashboard-card">
          <FaCheckCircle size={48} className="text-success mb-3" />
          <h3>Completed Orders</h3>
          <div className="number">{stats.completedOrders}</div>
        </div>
        
        <div className="dashboard-card">
          <FaDollarSign size={48} className="text-success mb-3" />
          <h3>Total Revenue</h3>
          <div className="number">₹{stats.totalRevenue.toFixed(2)}</div>
        </div>
        
        <div className="dashboard-card">
          <FaBox size={48} className="text-info mb-3" />
          <h3>Total Products</h3>
          <div className="number">{products.length}</div>
        </div>
        
        <div className="dashboard-card">
          <FaCheckCircle size={48} className="text-success mb-3" />
          <h3>Available Products</h3>
          <div className="number">{availableProducts.length}</div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Quick Actions</h4>
              <div className="d-grid gap-2">
                <Link to="/admin/orders" className="btn btn-primary">
                  <FaClipboardList className="me-2" />
                  Manage Orders
                </Link>
                <Link to="/admin/products" className="btn btn-success">
                  <FaBox className="me-2" />
                  Manage Products
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Recent Activity</h4>
              <div className="list-group list-group-flush">
                <div className="list-group-item d-flex justify-content-between align-items-center">
                  <span>Total Orders Today</span>
                  <span className="badge bg-primary rounded-pill">{stats.totalOrders}</span>
                </div>
                <div className="list-group-item d-flex justify-content-between align-items-center">
                  <span>Pending Orders</span>
                  <span className="badge bg-warning rounded-pill">{stats.pendingOrders}</span>
                </div>
                <div className="list-group-item d-flex justify-content-between align-items-center">
                  <span>Available Products</span>
                  <span className="badge bg-success rounded-pill">{availableProducts.length}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 